import React, {useState, useContext} from 'react'; 
import { Modal, Button } from 'react-bootstrap';
import { FeedContext } from '../../../utils/context/feedContext';

const BlockModal = ({showModal, postId, handleClose}) => {

    const { handleBlockByPostId } = useContext(FeedContext);

    const handleBlock = async() => {
        // Call the block function from the context
        await handleBlockByPostId(postId);
        handleClose(); 
    }

    return(
        <Modal centered show={showModal} onHide={handleClose}>
            <Modal.Header closeButton>
                Block User
            </Modal.Header>
            <Modal.Body>
                Are you sure you want to block this user?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={handleBlock}>
                    Block
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default BlockModal; 